import type { AuthenticationResult } from '@azure/msal-browser';

type TokenRefreshFn = () => Promise<AuthenticationResult | undefined>;

let tokenRefreshFn: TokenRefreshFn | null = null;

export const registerTokenRefresh = (fn: TokenRefreshFn) => {
  tokenRefreshFn = fn;
};

/**
 * Clear the registered token refresh function.
 *
 * If `fn` is provided, the registration is only cleared when it matches the
 * currently-registered function. This prevents a disposed MsalManager from
 * accidentally clearing a registration that a newer instance has already
 * installed.
 */
export const clearTokenRefresh = (fn?: TokenRefreshFn) => {
  if (fn === undefined || tokenRefreshFn === fn) {
    tokenRefreshFn = null;
  }
};

export const refreshTokenHandler = async (): Promise<
  AuthenticationResult | undefined
> => {
  if (!tokenRefreshFn) {
    console.warn(
      'Token refresh not registered. MsalManager may not be initialized yet.'
    );
    return undefined;
  }
  return tokenRefreshFn();
};
